import React from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'

import { _Ellipsis } from './styles'

const EllipsisText = (props) => {
  const noCssProps = R.dissoc('className', props)
  return (
    <_Ellipsis
      {...noCssProps}
      className={props.className || 'ellipsisText'}
    >
      {props.children || ''}
    </_Ellipsis>
  )
}
EllipsisText.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

export default EllipsisText
